import { render, staticRenderFns } from "./Topic2Activity.vue?vue&type=template&id=00e3ae06&scoped=true"
import script from "./Topic2Activity.vue?vue&type=script&lang=js"
export * from "./Topic2Activity.vue?vue&type=script&lang=js"
import style0 from "./Topic2Activity.vue?vue&type=style&index=0&id=00e3ae06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e3ae06",
  null
  
)

export default component.exports